import type { ButtonHTMLAttributes } from 'react';
import { cn } from './cn';

type Variante = 'principal' | 'secondaire' | 'discret';
type Taille = 'md' | 'sm';

const variantes: Record<Variante, string> = {
  principal: 'bg-brand text-white shadow-glow border-transparent hover:brightness-110',
  secondaire: 'bg-surface text-ink border-border hover:bg-surface-hover',
  discret: 'bg-transparent text-muted border-transparent hover:bg-surface-hover hover:text-ink',
};

const tailles: Record<Taille, string> = {
  md: 'h-[38px] px-3.5 text-[13px] rounded-[10px]',
  sm: 'h-[30px] px-2.5 text-xs rounded-lg',
};

export function Button({
  variante = 'secondaire',
  taille = 'md',
  className,
  type = 'button',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variante?: Variante; taille?: Taille }) {
  return (
    <button
      type={type}
      className={cn(
        'inline-flex items-center justify-center gap-2 border font-medium whitespace-nowrap transition',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
        'disabled:cursor-not-allowed disabled:opacity-60 [&_svg]:size-4',
        variantes[variante],
        tailles[taille],
        className
      )}
      {...props}
    />
  );
}
